import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';

import BaseThreatPreventionExceptions from '../../AbstractObjects/GatewayPlan/InnerPages/BaseThreatPreventionExceptions';
import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import {ObjectTypes} from '../../../../api/consts';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import SMCLink from '../../../../components/Simple/SMCLink';
import {threatPreventionExceptionIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.threatPreventionExceptions;
const pageId = pageSchema.pageId;

function GatewayThreatPreventionExceptions({
    gatewayObject,
    planObject,
    setGatewayData
}) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const gatewayName = gatewayObject[GatewayGetSchema.id];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData(pageId, planPage);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);


    return (
        <>
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.THREAT_PREVENTION_EXCEPTIONS')}
            icon={threatPreventionExceptionIcon}
        >
            <BaseThreatPreventionExceptions
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
                baseObjectName={gatewayName}
                objectType={ObjectTypes.GATEWAY}
            />
        </LockToPlanContainer>
        <Indentation>
            <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.TpExceptions')}><SMCIcon style={{ verticalAlign: 'middle' }} icon="seamlessLogin" /> {t('SMP.ACCESS_GATEWAY.TP_EX')}</SMCLink>
        </Indentation>
        </>
    );
}

export default GatewayThreatPreventionExceptions;